import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-feature-not-supported',
    templateUrl: './feature-not-supported.component.html',
    styleUrls: ['./feature-not-supported.component.scss'],
    standalone: false
})
export class FeatureNotSupportedComponent {

  constructor(public matdialogRef: MatDialogRef<FeatureNotSupportedComponent>) {}
}
